import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerSymbolGraphic } from "@visactor/vrender-core/register/graphic";

import { symbolModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindSymbolCanvasPickerContribution } from "../picker/contributions/canvas-picker/symbol-module";

import { bindSymbolMathPickerContribution } from "../picker/contributions/math-picker/symbol-module";

function _registerSymbol() {
    if (_registerSymbol.__loaded) return;
    _registerSymbol.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerSymbolGraphic(), symbolModule({
        bind: legacyContext.bind
    }), browser ? bindSymbolCanvasPickerContribution(legacyContext) : bindSymbolMathPickerContribution(legacyContext);
}

_registerSymbol.__loaded = !1;

export const registerSymbol = _registerSymbol;
//# sourceMappingURL=register-symbol.js.map